import { useState } from "react";

export function useLaggedFlag(value: boolean, isStale: boolean): boolean {
    const [laggedValue, setLaggedValue] = useState(value);

    if (!isStale && laggedValue !== value) {
        setLaggedValue(value);
    }

    return laggedValue;
}
